import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5cd3d1c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","flex-direction":"column","flex-shrink":"0"} }
const _hoisted_2 = { class: "el-card" }
const _hoisted_3 = { class: "header cm-align-center" }
const _hoisted_4 = { class: "title cm-align-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "sub-header" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text-title cm-align-center;" }
const _hoisted_9 = {
  key: 1,
  style: {"line-height":"1.3rem","word-break":"break-all"}
}

import { getSvgIconDataUrl } from '@/utils/svg-icon-data-url'

import IPColumn from '@/views/dashboard/_components/ip-column/IPColumn.vue';
import { computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import { SensitiveWordsFileOutgoingResponse } from '../service';
import { getApprovalChannelI18nKey, getApprovalChannelValue } from '../types/approval-terminal-file-outsourcing';
import { formatTimeStamp } from '@/utils/time';


export default /*#__PURE__*/_defineComponent({
  __name: 'describe-item',
  props: {
  colOpt: {
    type: Object,
    default: () => ({ span: 1, style: { 'margin-right': '10px' } })
  },
  valColOpt: {
    type: Object,
    default: () => ({ span: 18 })
  },
  mainList: {
    required: true,
    type: Array as PropType<any[]>
  },
  data: {
    required: true,
    type: Object as PropType<SensitiveWordsFileOutgoingResponse>
  },
},
  setup(__props) {

const { t, locale } = useI18n()

const props = __props

const softImgName = computed(() => getApprovalChannelValue(props.data.soft_name) ?? '')

const channelDisp = computed(() => {
  void locale.value
  const key = getApprovalChannelI18nKey(props.data.soft_name)
  return key ? t(key) : props.data.soft_name
})

const statusEntry = computed(() => {
  void locale.value
  const map: Record<number, { text: string; type: string }> = {
    1: { text: t('approvalTerminalFileOutsourcing.statusPreview'), type: 'warning' },
    3: { text: t('approvalTerminalFileOutsourcing.statusRejected'), type: 'danger' },
    2: { text: t('approvalTerminalFileOutsourcing.statusAgreed'), type: 'success' },
    4: { text: t('approvalTerminalFileOutsourcing.statusInvalid'), type: 'info' },
  }
  return map[props.data.apply_state]
})

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_unref(getApprovalChannelValue)(__props.data.soft_name))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                height: "20",
                class: "cm-ui-mr10",
                alt: "",
                style: {"object-fit":"cover"},
                src: _unref(getSvgIconDataUrl)(`views/dashboard/data-safe/anti-external-control/assets/approvalType/${softImgName.value}`)
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_unref(t)('approvalTerminalFileOutsourcing.outboundViaChannel', { channel: channelDisp.value })), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('approvalTerminalFileOutsourcing.applyTime')), 1),
          _createVNode(_component_el_divider, { direction: "vertical" }),
          _createElementVNode("span", null, _toDisplayString(_unref(formatTimeStamp)(__props.data.apply_time, 'YYYY-MM-DD HH:mm')), 1),
          _createVNode(_component_el_divider, {
            direction: "vertical",
            "border-style": "dashed"
          }),
          _createElementVNode("span", null, _toDisplayString(_unref(t)('approvalTerminalFileOutsourcing.auditStatus')), 1),
          (statusEntry.value)
            ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 0,
                type: statusEntry.value?.type,
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(statusEntry.value.text), 1)
                ]),
                _: 1
              }, 8, ["type"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, "--"))
        ]),
        _renderSlot(_ctx.$slots, "header-right", { row: __props.data })
      ]),
      _createVNode(_component_el_row, {
        class: "main",
        style: {"display":"flex"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.mainList, (containerItem, colIdx) => {
            return (_openBlock(), _createBlock(_component_el_col, _mergeProps({
              class: "gap-x-20",
              ref_for: true
            }, containerItem.colOpt, { key: colIdx }), {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _renderSlot(_ctx.$slots, containerItem.titleKey, {
                    val: __props.data[containerItem.titleKey],
                    item: __props.data
                  }, () => [
                    _createTextVNode(_toDisplayString(__props.data[containerItem.titleKey]), 1)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((typeof containerItem.describeListByType === 'function' ? containerItem.describeListByType(__props.data):containerItem.describeListByType), (describe) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: describe.prop + (describe.label || '')
                  }, [
                    ((describe?.show ? describe?.show?.(__props.data) : (__props.data[describe.prop] ||  (describe.allowEmpty?? containerItem.allowEmpty))))
                      ? (_openBlock(), _createBlock(_component_el_row, {
                          key: 0,
                          style: {"display":"flex","margin-bottom":"10px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, _mergeProps({
                              class: "label-cm",
                              ref_for: true
                            }, __props.colOpt ?? describe.colOpt), {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(describe.label), 1)
                              ]),
                              _: 2
                            }, 1040),
                            _createVNode(_component_el_col, _mergeProps({
                              class: "cm-align-center",
                              ref_for: true
                            }, __props.valColOpt ?? describe.valColOpt), {
                              default: _withCtx(() => [
                                (describe.type === 'IP')
                                  ? (_openBlock(), _createBlock(IPColumn, {
                                      key: 0,
                                      cip: __props.data.client_ip,
                                      sip: __props.data.system_ip
                                    }, null, 8, ["cip", "sip"]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(describe?.formatter?.(__props.data[describe.prop]) ??
                      __props.data[describe.prop]), 1))
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              _: 2
            }, 1040))
          }), 128))
        ]),
        _: 3
      })
    ])
  ]))
}
}

})